"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copperFurnaceConfig = void 0;
exports.copperFurnaceConfig = {
    name: 'copper-furnace',
    fullname: 'Copper Furnace',
    description: 'Converts copper ore into copper ingots.',
    type: 'factory',
    width: 1,
    height: 1,
    levelMax: 4,
    canBeDisabled: true,
    requiredTechnology: 'copper',
    levels: [
        { level: 0, constructionCosts: {}, time: 100, provides: { copper: 1 }, costs: { energy: 1, 'copper-ore': 1 }, stores: {} },
        { level: 1, constructionCosts: { stone: 30 }, time: 80, provides: { copper: 1 }, costs: { energy: 1, 'copper-ore': 1 }, stores: {} },
        { level: 2, constructionCosts: { stone: 50 }, time: 60, provides: { copper: 1 }, costs: { energy: 1, 'copper-ore': 1 }, stores: {} },
        { level: 3, constructionCosts: { iron: 50, stone: 50 }, time: 30, provides: { copper: 1 }, costs: { energy: 1, 'copper-ore': 1 }, stores: {} },
        { level: 4, constructionCosts: { iron: 100, stone: 100 }, time: 10, provides: { copper: 1 }, costs: { energy: 1, 'copper-ore': 1 }, stores: {} },
    ],
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/config/buildings/copperfurnace.js
// module id = 9Qc9
// module chunks = 0